import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';
import rtl from 'styled-components-rtl';

/**
 * Styles for CardDetails organism
 * Leverages global Bootstrap utilities (d-flex, align-items-center, mt-*, etc.)
 * Only custom styles that aren't available in global classes are defined here
 */
export const StyledCardDetails = styled.div`
  ${rtl`
    /* Custom border and shadow for card container */
    .card-detail--border {
      border: ${baseVariables.border.borderWidth02} ${baseVariables.border.borderStyleDefault} ${
    baseVariables.color.neutral20
  };
      border-radius: ${toRem(16)};
      box-shadow: 0 ${toRem(4)} ${toRem(20)} ${baseVariables.shadows.boxShadowTile};
      margin-top: ${toRem(72)};

      @media ${baseVariables.mediaQuery.md} {
        margin-top: 0;
      }
    }

    /* Custom link display behavior */
    .card-detail-wrapper .custom-link {
      display: block;

      @media ${baseVariables.mediaQuery.lg} {
        display: inline;
      }
    }

    .card-detail-wrapper .points-underlined {
       font-family: ${baseVariables.font.fontSwissCondensed};
        border-bottom: ${toRem(5)} ${baseVariables.border.borderStyleDefault} ${baseVariables.color.accent10};
        display: block;
        width: fit-content;
        margin: ${toRem(4)} auto ${toRem(8)} auto;
        @media ${baseVariables.mediaQuery.md} {
          margin: ${toRem(8)} auto ${toRem(12)} auto;
        }
        @media ${baseVariables.mediaQuery.lg} {
          margin: 0;
          display: inline;
        }
    }

    /* Accordion button position override */
    .card-detail-wrapper .accordion-button {
      position: static;
    }

    /* Responsive vertical alignment utilities */
    .middle-align {
      vertical-align: super;

      @media ${baseVariables.mediaQuery.md} {
        vertical-align: unset;
      }

      @media ${baseVariables.mediaQuery.lg} {
        vertical-align: super;
      }
    }

    /* Responsive flex/block toggle - can't be achieved with single Bootstrap class */
    .vertical-align {
      display: flex;
      align-items: center;
      justify-content: center;

      @media ${baseVariables.mediaQuery.md} {
        display: block;
      }

      @media ${baseVariables.mediaQuery.lg} {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    /* Responsive top border - Desktop only */
    .top-horizontal-border {
      border: none;

      @media ${baseVariables.mediaQuery.md} {
        padding-top: ${toRem(16)};
        display: block;
        border-top: ${baseVariables.border.borderWidth02} ${baseVariables.border.borderStyleDefault} ${
    baseVariables.color.neutral30
  };
      }
    }

    /* RTE content spacing - uses :has() for parent-child selector */
    p:has(> span.t-subtitle-m) {
      margin-bottom: ${toRem(8)};
    }

    p:has(> span.t-numbers-s) {
      margin-bottom: ${toRem(16)};
    }

    .flex-align-center {
      display: flex;
      align-items: center;
    }
  `}
`;
